import { render, staticRenderFns } from "./BreadcrumbItemDropdown.vue?vue&type=template&id=314d7fd2&scoped=true"
import script from "./BreadcrumbItemDropdown.vue?vue&type=script&lang=js"
export * from "./BreadcrumbItemDropdown.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbItemDropdown.vue?vue&type=style&index=0&id=314d7fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314d7fd2",
  null
  
)

export default component.exports